import { useQuery } from "@apollo/client";

import { AspectGranularity, AspectInput, AspectOutput, AspectType } from "types/generated";

import { GroupByKey } from "../../Chart/constants";
import { GET_ASPECT_TOTALS } from "../../gql";
import { TimeFilter } from "../../types";
import { adaptTimeFilterForApi } from "../../utils";
import RunMinutesTotalsSkeleton from "./Skeleton";
import RunMinutesTotalsView from "./View";

type RunMinutesTotalsProps = {
  timeFilter: TimeFilter;
};

const RunMinutesTotals = ({ timeFilter }: RunMinutesTotalsProps) => {
  const { data, loading } = useQuery<
    { usageAspect: Pick<AspectOutput, "summary"> },
    { input: AspectInput }
  >(GET_ASPECT_TOTALS, {
    variables: {
      input: {
        type: AspectType.RunMinutes,
        groupBy: GroupByKey.Public,
        timeFilter: adaptTimeFilterForApi(timeFilter),
        granularity: AspectGranularity.Day,
      },
    },
    fetchPolicy: "no-cache",
  });

  const totals = data?.usageAspect?.summary?.totals;

  return (
    <>
      {loading && <RunMinutesTotalsSkeleton />}
      {!loading && totals && (
        <RunMinutesTotalsView
          privateMinutes={totals.find(({ name }) => name === "private")?.value || 0}
          publicMinutes={totals.find(({ name }) => name === "public")?.value || 0}
        />
      )}
      {/** TODO: show something if there are no totals */}
    </>
  );
};

export default RunMinutesTotals;
